import { useEffect, useState } from "react";
import { fetchRanking } from "../aggregator";
import { buildRanking } from "../ranking";
import translate from "../locales";

/**
 * single / zero or plural (all the rest)
 *
 * @param {number} count
 * @returns {string}
 */
export function voteLabel(count) {
  return translate(count === 1 ? "ranking.vote" : "ranking.votes", { count });
}

/**
 * The ranking list. No styling, inherited from host.
 *
 * The embed appears probably more than once on the site, so
 * we use `data-fathom-source` to keep track in Fathom.
 *
 * @param {{source?: string}} props
 */
export default function Ranking({ source }) {
  const [entries, setEntries] = useState();

  useEffect(() => {
    window.fathom?.trackEvent(`ranking embed: ${source || "no-source"}`);
  }, [source]);

  useEffect(() => {
    fetchRanking().then((rows) => {
      if (!rows) return;

      setEntries(buildRanking(rows));
    });
  }, []);

  if (!entries) return null;

  if (entries.length === 0) {
    return (
      <p className="ranking__empty">{translate("ranking.not_voted_yet")}</p>
    );
  }

  return (
    <ol className="ranking">
      {entries.map(({ rank, votes, project }) => (
        <li className="ranking__item" key={project.id} value={rank}>
          {project.link ? (
            <a className="ranking__link" href={project.link}>
              {project.title}
            </a>
          ) : (
            project.title
          )}{" "}
          <span className="ranking__votes">{voteLabel(votes)}</span>
        </li>
      ))}
    </ol>
  );
}
